import React, { useState } from 'react'
import Modal from '../../components/common/Modal';

const FeeDiscountData = [
    {
        id: 1,
        academicYear: "2026-67",
        Curriculum: "CBSC",
        DiscountName: "123",
        amount: "2000",
        Type: "Percentage",
    },
    {
        id: 2,
        academicYear: "2026-67",
        Curriculum: "CBSC",
        DiscountName: "123",
        amount: "2000",
        Type: "Percentage",
    },
    {
        id: 3,
        academicYear: "2026-67",
        Curriculum: "CBSC",
        DiscountName: "123",
        amount: "2000",
        Type: "Percentage",
    },
];
const FeeDiscount = () => {
    const [formData, setFormData] = useState(FeeDiscountData);

    const [showViewModal, setShowViewModal] = useState(false)

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log(formData);
    };

    return (
        <>
            <div>
                <div className="page-header mb-3">
                    <div><h2>Discount Types</h2></div>
                    <button className="btn btn-primary" onClick={() => setShowViewModal(true)}>➕ Add Fee Discount</button>
                </div>
                 
                <div className="card">
                    <div className="card-body">
                        <div className="table-responsive border">
                            <table className="table fee-table">
                                <thead>
                                    <tr>
                                        <th>S.No </th>
                                        <th>Discount name</th>
                                        <th>Academic Year </th>
                                        <th>curriculum </th>
                                        <th>Amount </th>
                                        <th>Type </th>
                                        <th className="text-center">Actions</th>
                                    </tr>

                                </thead>

                                <tbody>
                                    <tr>
                                        <td>1</td>
                                        <td>2k</td>
                                        <td>2026-27</td>
                                        <td>2026-27_SSC</td>
                                        <td>Rs. 2,000</td>
                                        <td>Fixed</td>
                                        <td></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <button className="export-btn">
                            Export to Excel
                        </button>

                    </div>
                </div>


                <Modal
                    show={showViewModal}
                    onClose={() => setShowViewModal(false)}
                    title="Add Fee Discounts Type"
                    size="md"
                >
                    <div className="container-fluid py-3">
                        <form onSubmit={handleSubmit}>

                            <div className="mb-2">
                                <label className="form-label">
                                    Select Academic Year
                                </label>

                                <select
                                    className="form-select"
                                    name="academicYear"
                                    value={formData.academicYear}
                                    onChange={handleChange}
                                >
                                    <option value="">--- Select ---</option>
                                    <option value="2025-2026">2025-2026</option>
                                    <option value="2026-2027">2026-2027</option>
                                </select>
                            </div>

                            <div className="mb-2">
                                <label className="form-label">
                                    Curriculum
                                </label>

                                <select
                                    className="form-select"
                                    name="Curriculum"
                                    value={formData.Curriculum}
                                    onChange={handleChange}
                                >
                                    <option value="">--- Select ---</option>
                                    <option value="CBSC">CBSC</option>
                                    <option value="SSC">SSC</option>
                                </select>
                            </div>


                            <div className="mb-2">
                                <label className="form-label">
                                    Discount Name
                                </label>

                                <input
                                    type="text"
                                    className="form-control"
                                    name="feeName"
                                    value={formData.DiscountName}
                                    onChange={handleChange}
                                />
                            </div>


                            <div className="mb-2">
                                <label className="form-label">
                                    Amount
                                </label>

                                <input
                                    type="text"
                                    className="form-control"
                                    name="feeCode"
                                    value={formData.amount}
                                    onChange={handleChange}
                                />
                            </div>

                            <div className="mb-2">
                                <label className="form-label">
                                    Type
                                </label>

                                <select
                                    className="form-select"
                                    name="Type"
                                    value={formData.Type}
                                    onChange={handleChange}
                                >
                                    <option value="">--- Select ---</option>
                                    <option value="CBSC">Fixed Amount</option>
                                    <option value="SSC">percentage</option>
                                </select>
                            </div>
                            <hr/>
                            <div className="mt-4">
                                <button
                                    type="submit"
                                    className="btn btn-info text-white me-2 px-4"
                                >
                                    Submit
                                </button>

                                <button
                                    type="button"
                                    className="btn btn-light border px-4"
                                >
                                    Cancel
                                </button>
                            </div>
                        </form>
                    </div>
                </Modal>
            </div>
        </>
    )
}

export default FeeDiscount